class Image {
  constructor({ id, attributes }) {
    this.id = id;

    // eslint-disable-next-line no-restricted-syntax
    for (const key in attributes) {
      if ({}.hasOwnProperty.call(attributes, key)) {
        this[key] = attributes[key];
      }
    }
  }
}

export default Image;
